import { useState, useEffect } from 'react';

import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { mathFormat, showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { getValidOptionValue } from '@intelligence/utils/commonUtils';
import {
  analysisPlatformTopInfo,
  getStoreRankTopName,
} from '@/pages/intelligence/_config/storeRank/utils';

export default function useStoreRankMoreCoreLineChart(props: any) {
  const { entityType, topChartName, dateType = 'daily', platformTopMetrics = [], data } = props;

  const { locale, formatMessage } = useIntlExtend();

  const [currentLineData, setCurrentLineData] = useState([]);
  const [xLabel, setXLabel] = useState<any>([]);
  const [seriesData, setSeriesData] = useState([]);
  const [segments, setSegments] = useState<any[]>([]);
  const [segment, setSegment] = useState('');
  const [legendSelected, setLegendSelected] = useState({});
  const [legendData, setLegendData] = useState<any[]>([]);

  const analysisSegments = (payload: any) => {
    if (!payload) return [];
    const keys = Object.keys(payload);
    return keys
      .sort((a, b) => {
        const aIdx = platformTopMetrics?.findIndex((item: string) => item?.startsWith(a));
        const bIdx = platformTopMetrics?.findIndex((item: string) => item?.startsWith(b));
        return aIdx - bIdx;
      })
      .map((key) => {
        const { platform, top } = analysisPlatformTopInfo(key);
        const topLocaleKey = getStoreRankTopName(entityType, top, formatMessage);
        return {
          value: key,
          label: formatMessage({ id: topLocaleKey }),
          icon: getDataSourceIcon(platform),
        };
      });
  };

  // 获取当前指标echart数据
  const currentLine = (type: string) => {
    const metricType = Object.keys(data);
    if (metricType?.length && metricType?.includes(type)) {
      const source = JSON.parse(JSON.stringify(data))[type];
      setCurrentLineData(source);
    } else {
      setCurrentLineData([]);
    }
  };

  const lineDataFormatter = (list: any) => {
    const xLabel = list?.[0]?.history?.map((v: any) => showTimeByDateType(v?.time || v?.date, dateType));
    const legendSelectedTmp: { [key: string]: boolean } = {};
    const legendDataTmp: any[] = [];
    const series = list?.map((v: any) => {
      const seriesNameTmp = v?.name;
      legendSelectedTmp[seriesNameTmp] = true;
      const legendDataItemTmp = {
        name: seriesNameTmp,
        icon: 'circle',
      };
      legendDataTmp.push(legendDataItemTmp);
      return {
        name: v?.name,
        type: 'line',
        symbol: 'circle',
        data: v?.history?.map((item: any) => item?.value || item?.game_rank),
      };
    });
    setXLabel(xLabel);
    setSeriesData(series);
    setLegendSelected({ ...legendSelectedTmp });
    setLegendData(legendDataTmp);
  };

  // y轴label格式化
  const yAxisFormatter = (value: any) => `${mathFormat(value, true)}`;

  const legendsCustomMade = () => ({
    type: 'scroll',
    orient: 'horizontal', // 横向
    pageIconColor: '#000', // 翻页箭头颜色
    // selectedMode: false,
    pageIconSize: 12,
    pageTextStyle: {
      color: '#000', // 翻页数字颜色
    }, // 翻页数字设置
    show: true,
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    inactiveColor: '#ccc', // 关闭时图例颜色
    inactiveBorderWidth: 0,
    inactiveBorderColor: '#ffffff', // 默认存在#ccc，看起来会比设置的icon图例大小有区别
    borderWidth: 0,
    bottom: 0,
    left: 'center',
    textStyle: {
      color: '#888888',
      fontSize: 12,
      // padding: [0, 30, 0, 0],
    },
    data: [...legendData],
    selected: { ...legendSelected },
    itemGap: 20,
  });

  useEffect(() => {
    lineDataFormatter(currentLineData);
  }, [currentLineData]);

  useEffect(() => {
    const segmentsTmp = analysisSegments(data);
    const segmentTmp = getValidOptionValue(topChartName, segmentsTmp);
    setSegments(segmentsTmp);
    setSegment(segmentTmp);
    currentLine(segmentTmp);
  }, [topChartName, data]);

  useEffect(() => {
    const segmentsTmp = analysisSegments(data);
    setSegments(segmentsTmp);
  }, [locale]);

  return {
    seriesData,
    xAxisData: xLabel,
    yAxisFormatter,
    createLegendsCustomMade: legendsCustomMade(),
    currentLine,
    segments,
    setSegment,
    segment,
  };
}
